package com.artvending.warden


abstract class Language {
	abstract val TEST_MODE: String
	abstract val SOMETHING_WRONG: String
	abstract val ERROR: String
	abstract val NO_DATA: String
	abstract val LOADING_DATA: String
	abstract val CALENDAR: String
	abstract val LIST: String
	abstract val YOU_ARE_LATE: String
	abstract val YOU_ARE_IN_TIME: String
	abstract val YOU_LATED: String
	abstract val INCOME_FIXED: String
	abstract val BAD_OUTCOME_FIXED: String
	abstract val OUTCOME_FIXED: String
	abstract val YOUR_WORKING_CALENDAR: String
	abstract val MONTH_REMARKS: String
	abstract val INCOME_DIDNT_FIX: String
	abstract val LATE_ON: String
	abstract val LATE: String
	abstract val BAD_OUTCOME: String
	abstract val OUTCOME_DIDNT_FIX: String
	abstract val USER_DIDNT_SET: String
	abstract val INCOME: String
	abstract val OUTCOME: String
	abstract val RE_OUTCOME: String
	abstract val SCAN_FROM_TABLET: String
	abstract val LOAD_SCANNER: String
	abstract val SCAN_ERROR: String
	abstract val SCAN_PERMISSION_ERROR: String
	abstract val BACK: String
	abstract val SET_USER_SUCCESS: String
	abstract val USER_DIDNT_SET_2: String
	abstract val UNKNOWN_ERROR: String
	abstract val WARNING: String
	abstract val GEOLOCATION_WARNING: String
	abstract val DATA_SENDING: String
	abstract val GEOLOCATION_GETTING: String
	abstract val DONE: String
	abstract val FIX_TIME: String
	abstract val UPDATE_PAGE_QUESTION: String
	abstract val HOME: String
	abstract val SCANNER: String
	abstract val HISTORY: String
	abstract val GEOLOCATION_ERROR: String
	abstract val GEOLOCATION_PERMISSION_ERROR: String
	abstract val VACATION: String
	abstract val IN_WORK: String
	abstract val IN_WORK2: String
	abstract val ON_OBJECT: String
	abstract val REMOTE_WORK: String
	abstract val SERVICE_FAIL: String
	abstract val MONDAY: String
	abstract val SUNDAY: String
	abstract val TUESDAY: String
	abstract val WEDNESDAY: String
	abstract val THURSDAY: String
	abstract val FRIDAY: String
	abstract val SATURDAY: String
	abstract val JANUARY: String
	abstract val FEBRUARY: String
	abstract val MARCH: String
	abstract val APRIL: String
	abstract val MAY: String
	abstract val JUNE: String
	abstract val JULY: String
	abstract val AUGUST: String
	abstract val SEPTEMBER: String
	abstract val OCTOBER: String
	abstract val NOVEMBER: String
	abstract val DECEMBER: String
	abstract val JANUARY_2: String
	abstract val FEBRUARY_2: String
	abstract val MARCH_2: String
	abstract val APRIL_2: String
	abstract val MAY_2: String
	abstract val JUNE_2: String
	abstract val JULY_2: String
	abstract val AUGUST_2: String
	abstract val SEPTEMBER_2: String
	abstract val OCTOBER_2: String
	abstract val NOVEMBER_2: String
	abstract val DECEMBER_2: String
	abstract val MINUTE: String
	abstract val MINUTES: String
	abstract val MINUTES_2: String
	abstract val HOUR: String
	abstract val HOURS: String
	abstract val HOURS_2: String
	abstract val CREATE_SCANNER_ERROR: String
	abstract val STOP_SCANNER_ERROR: String
	abstract val SCANNER_HANDLE_ERROR: String
	abstract val CREATE_SCANNER_PARAMETER_ERROR: String
	abstract val START_SCAN_ERROR: String
	abstract val BUSINESS_TRIP: String
	abstract val SICK_LEAVE: String
	abstract val MATERNITY_LEAVE: String
	abstract val DUTY_ON_ZAHODNIA: String
	abstract val OUT_OF_POCKET_TIME_OFF: String
	abstract val WEEKEND_WORK: String
	abstract val ABSENCE_TO_3_HOURS: String
	abstract val ABSENCE_MORE_3_HOURS: String
	abstract val UNEXCUSED_ABSENCE: String
	abstract val TRUANCY: String
	abstract val OTHER: String
	abstract val UNKNOWN_ABSENCE_MODE: String
	abstract val INCORRECT_QR: String
	abstract val USER_IS_OUTSIDE_OFFICE: String
	abstract val TIME_GOT: String
	abstract val CANCEL: String
	abstract val SET_USER: String
	abstract val SEND_QUEUE: String
	abstract val QUEUE_WARNING: String
	abstract val OFFLINE_ERROR: String
	abstract val GEOLOCATION_GETTING_OFFLINE: String
	abstract val DEVICE_NOT_ALLOWED: String
	abstract val WAIT_FINISH: String
}


class RusLanguage : Language() {
	override val TEST_MODE = "Тестовый режим"
	override val SOMETHING_WRONG = "Что-то пошло не так. Попробуйте снова."
	override val ERROR = "Ошибка"
	override val NO_DATA = "Нет данных"
	override val LOADING_DATA = "Загружаем данные"
	override val CALENDAR = "Календарь"
	override val LIST = "Список"
	override val YOU_ARE_LATE = "Вы опаздываете на"
	override val YOU_ARE_IN_TIME = "Вы успеваете"
	override val YOU_LATED = "Зафиксировано опоздание в"
	override val INCOME_FIXED = "Приход зафиксирован в"
	override val BAD_OUTCOME_FIXED = "Зафиксирован ранний уход в"
	override val OUTCOME_FIXED = "Уход зафиксирован в"
	override val YOUR_WORKING_CALENDAR = "Ваш рабочий график"
	override val MONTH_REMARKS = "Замечания за месяц"
	override val INCOME_DIDNT_FIX = "Не зафиксирован приход"
	override val LATE_ON = "Опоздание на"
	override val LATE = "Опоздание"
	override val BAD_OUTCOME = "Уход раньше на"
	override val OUTCOME_DIDNT_FIX = "Не зафиксирован уход"
	override val USER_DIDNT_SET = "Пользователь не установлен!"
	override val INCOME = "Приход"
	override val OUTCOME = "Уход"
	override val RE_OUTCOME = "Зафиксировать повторно"
	override val SCAN_FROM_TABLET = "Отсканируйте QR-код с экрана специального планшета."
	override val LOAD_SCANNER = "Загружаем сканер"
	override val SCAN_ERROR = "Ошибка сканера"
	override val SCAN_PERMISSION_ERROR = "Ошибка запроса разрешения"
	override val BACK = "Вернуться"
	override val SET_USER_SUCCESS = "Пользователь успешно установлен"
	override val USER_DIDNT_SET_2 = "Пользователь не установлен. Обратитесь к системному администратору."
	override val UNKNOWN_ERROR = "Неизвестная ошибка"
	override val WARNING = "Предупреждение"
	override val GEOLOCATION_WARNING = "Для фиксации прихода/ухода необходимо включить геолокацию."
	override val DATA_SENDING = "Время зафиксировалось. Отправляем данные"
	override val DONE = "Готово!"
	override val FIX_TIME = "Время фиксации"
	override val UPDATE_PAGE_QUESTION = "Обновить страницу?"
	override val HOME = "Главная"
	override val SCANNER = "Сканер"
	override val HISTORY = "История"
	override val GEOLOCATION_ERROR = "Ошибка получения геолокации"
	override val GEOLOCATION_PERMISSION_ERROR = "Ошибка получения разрешение на геолокацию"
	override val VACATION = "Отпуск"
	override val IN_WORK = "На работе"
	override val ON_OBJECT = "На объекте"
	override val REMOTE_WORK = "Удалённо"
	override val SERVICE_FAIL = "Ошибка доступа к сервису"
	override val MONDAY = "пн"
	override val SUNDAY = "вс"
	override val TUESDAY = "вт"
	override val WEDNESDAY = "ср"
	override val THURSDAY = "чт"
	override val FRIDAY = "пт"
	override val SATURDAY = "сб"
	override val JANUARY = "Январь"
	override val FEBRUARY = "Февраль"
	override val MARCH = "Март"
	override val APRIL = "Апрель"
	override val MAY = "Май"
	override val JUNE = "Июнь"
	override val JULY = "Июль"
	override val AUGUST = "Август"
	override val SEPTEMBER = "Сентябрь"
	override val OCTOBER = "Октябрь"
	override val NOVEMBER = "Ноябрь"
	override val DECEMBER = "Декабрь"
	override val JANUARY_2 = "января"
	override val FEBRUARY_2 = "февраля"
	override val MARCH_2 = "марта"
	override val APRIL_2 = "апреля"
	override val MAY_2 = "мая"
	override val JUNE_2 = "июня"
	override val JULY_2 = "июля"
	override val AUGUST_2 = "августа"
	override val SEPTEMBER_2 = "сентября"
	override val OCTOBER_2 = "октября"
	override val NOVEMBER_2 = "ноября"
	override val DECEMBER_2 = "декабря"
	override val MINUTE = "минута"
	override val MINUTES = "минуты"
	override val MINUTES_2 = "минут"
	override val HOUR = "час"
	override val HOURS = "часа"
	override val HOURS_2 = "часов"
	override val CREATE_SCANNER_ERROR = "Ошибка создания сканера"
	override val STOP_SCANNER_ERROR = "Ошибка во время остановки сканера"
	override val SCANNER_HANDLE_ERROR = "Ошибка обработки скана"
	override val CREATE_SCANNER_PARAMETER_ERROR = "Ошибка при создании параметров сканера"
	override val START_SCAN_ERROR = "Ошибка начала сканирования"
	override val IN_WORK2 = "Отработал"
	override val BUSINESS_TRIP = "Командировка"
	override val SICK_LEAVE = "Больничный"
	override val MATERNITY_LEAVE = "Отпуск декретный"
	override val DUTY_ON_ZAHODNIA = "Дежурство на Заходней"
	override val OUT_OF_POCKET_TIME_OFF = "Отгул за свой счет"
	override val WEEKEND_WORK = "Работа в выходной"
	override val ABSENCE_TO_3_HOURS = "Отпросился по уважительной причине (отсутствие до 3 часов)"
	override val ABSENCE_MORE_3_HOURS = "Отпросился по уважительно причине больше 3-х часов"
	override val UNEXCUSED_ABSENCE = "Отпросился без уважительной причины"
	override val TRUANCY = "Прогул"
	override val OTHER = "Другое"
	override val UNKNOWN_ABSENCE_MODE = "Неизвестный тип отсутствия"
	override val INCORRECT_QR = "Некорректный QR-код"
	override val USER_IS_OUTSIDE_OFFICE = "Пользователь вне офиса"
	override val TIME_GOT = "Время фиксации получили."
	override val GEOLOCATION_GETTING = "Определяем геолокацию."
	override val GEOLOCATION_GETTING_OFFLINE = "Определяем геолокацию (может потребоваться интернет)."
	override val CANCEL = "Отменить"
	override val SET_USER = "Установить пользователя"
	override val SEND_QUEUE = "Отправка сохранённых фиксаций"
	override val QUEUE_WARNING = "Время зафиксировалось, но данные отправить не удалось (будут отправлены позже)."
	override val OFFLINE_ERROR = "Проверьте подключение к сети!"
	override val DEVICE_NOT_ALLOWED = "Использование приложение на этом устройстве запрещено."
	override val WAIT_FINISH = "Дождитесь завершения!"
}


class UkrLanguage : Language() {
	override val TEST_MODE = "Тестовий режим"
	override val SOMETHING_WRONG = "Щось пішло не так. Спробуйте знову."
	override val ERROR = "Помилка"
	override val NO_DATA = "Немає даних"
	override val LOADING_DATA = "Завантажуємо дані"
	override val CALENDAR = "Календар"
	override val LIST = "Список"
	override val YOU_ARE_LATE = "Ви спізнюєтеся на"
	override val YOU_ARE_IN_TIME = "Ви встигаєте"
	override val YOU_LATED = "Зафіксовано запізнення в"
	override val INCOME_FIXED = "Прихід зафіксовано в"
	override val BAD_OUTCOME_FIXED = "Зафіксовано ранній вихід у"
	override val OUTCOME_FIXED = "Відхід зафіксовано в"
	override val YOUR_WORKING_CALENDAR = "Ваш робочий графік"
	override val MONTH_REMARKS = "Зауваження за місяць"
	override val INCOME_DIDNT_FIX = "Не зафіксовано прихід"
	override val LATE_ON = "Запізнення на"
	override val LATE = "Запізнення"
	override val BAD_OUTCOME = "Вихід раніше на"
	override val OUTCOME_DIDNT_FIX = "Не зафіксовано відхід"
	override val USER_DIDNT_SET = "Користувач не встановлений!"
	override val INCOME = "Прихід"
	override val OUTCOME = "Вихід"
	override val RE_OUTCOME = "Зафіксувати повторно"
	override val SCAN_FROM_TABLET = "Відскануйте QR-код з екрана спеціального планшета."
	override val LOAD_SCANNER = "Завантажуємо сканер"
	override val SCAN_ERROR = "Помилка сканера"
	override val SCAN_PERMISSION_ERROR = "Помилка запиту дозволу"
	override val BACK = "Повернутися"
	override val SET_USER_SUCCESS = "Користувач успішно встановлений"
	override val USER_DIDNT_SET_2 = "Користувач не встановлений. Зверніться до системного адміністратора."
	override val UNKNOWN_ERROR = "Невідома помилка"
	override val WARNING = "Попередження"
	override val GEOLOCATION_WARNING = "Для фіксації приходу/відходу необхідно увімкнути геолокацію."
	override val DATA_SENDING = "Час зафіксувався. Надсилаємо дані"
	override val DONE = "Готово!"
	override val FIX_TIME = "Час фіксації"
	override val UPDATE_PAGE_QUESTION = "Оновити сторінку?"
	override val HOME = "Головна"
	override val SCANNER = "Сканер"
	override val HISTORY = "Історія"
	override val GEOLOCATION_ERROR = "Помилка отримання геолокації"
	override val GEOLOCATION_PERMISSION_ERROR = "Помилка отримання дозволу на геолокацію"
	override val VACATION = "Відпустка"
	override val IN_WORK = "На роботі"
	override val ON_OBJECT = "На об'єкті"
	override val REMOTE_WORK = "Віддалено"
	override val SERVICE_FAIL = "Помилка доступу до сервісу"
	override val SUNDAY = "нд"
	override val MONDAY = "пн"
	override val TUESDAY = "вт"
	override val WEDNESDAY = "ср"
	override val THURSDAY = "чт"
	override val FRIDAY = "пт"
	override val SATURDAY = "сб"
	override val JANUARY = "Січень"
	override val FEBRUARY = "Лютий"
	override val MARCH = "Березень"
	override val APRIL = "Квітень"
	override val MAY = "Травень"
	override val JUNE = "Червень"
	override val JULY = "Липень"
	override val AUGUST = "Серпень"
	override val SEPTEMBER = "Вересень"
	override val OCTOBER = "Жовтень"
	override val NOVEMBER = "Листопад"
	override val DECEMBER = "Грудень"
	override val JANUARY_2 = "січня"
	override val FEBRUARY_2 = "лютого"
	override val MARCH_2 = "березня"
	override val APRIL_2 = "квітня"
	override val MAY_2 = "травня"
	override val JUNE_2 = "червня"
	override val JULY_2 = "липня"
	override val AUGUST_2 = "серпня"
	override val SEPTEMBER_2 = "вересня"
	override val OCTOBER_2 = "жовтня"
	override val NOVEMBER_2 = "листопада"
	override val DECEMBER_2 = "грудня"
	override val MINUTE = "хвилина"
	override val MINUTES = "хвилини"
	override val MINUTES_2 = "хвилин"
	override val HOUR = "година"
	override val HOURS = "години"
	override val HOURS_2 = "годин"
	override val CREATE_SCANNER_ERROR = "Помилка створення сканера"
	override val STOP_SCANNER_ERROR = "Помилка під час зупинки сканера"
	override val SCANNER_HANDLE_ERROR = "Помилка обробки скана"
	override val CREATE_SCANNER_PARAMETER_ERROR = "Помилка під час створення параметрів сканера"
	override val START_SCAN_ERROR = "Помилка початку сканування"
	override val IN_WORK2 = "Відпрацював"
	override val BUSINESS_TRIP = "Відрядження"
	override val SICK_LEAVE = "Лікарняний"
	override val MATERNITY_LEAVE = "Відпустка декретна"
	override val DUTY_ON_ZAHODNIA = "Чергування на Заходній"
	override val OUT_OF_POCKET_TIME_OFF = "Відгул за власний рахунок"
	override val WEEKEND_WORK = "Робота у вихідний"
	override val ABSENCE_TO_3_HOURS = "Відпросився з поважної причини (відсутність до 3 годин)"
	override val ABSENCE_MORE_3_HOURS = "Відпросився з поважної причини більше 3-х годин"
	override val UNEXCUSED_ABSENCE = "Відпросився без поважної причини"
	override val TRUANCY = "Прогул"
	override val OTHER = "Інше"
	override val UNKNOWN_ABSENCE_MODE = "Невідомий тип відсутності"
	override val INCORRECT_QR = "Некоректний QR-код"
	override val USER_IS_OUTSIDE_OFFICE = "Користувач поза офісом"
	override val GEOLOCATION_GETTING = "Визначаємо геолокацію."
	override val GEOLOCATION_GETTING_OFFLINE = "Визначаємо геолокацію (може знадобитися інтернет)."
	override val TIME_GOT = "Час фіксації отримали."
	override val CANCEL = "Скасувати"
	override val SET_USER = "Встановити користувача"
	override val SEND_QUEUE = "Надсилання збережених фіксацій"
	override val QUEUE_WARNING = "Час зафіксувався, але дані відправити не вдалося (будуть відправлені пізніше)."
	override val OFFLINE_ERROR = "Перевірте підключення до мережі!"
	override val DEVICE_NOT_ALLOWED = "Використання застосунку на цьому пристрої заборонено."
	override val WAIT_FINISH = "Дочекайтеся завершення!"
}


class PolLanguage : Language() {
	override val TEST_MODE = "Tryb testowy"
	override val SOMETHING_WRONG = "Coś poszło nie tak. Spróbuj ponownie."
	override val ERROR = "Błąd"
	override val NO_DATA = "Brak danych"
	override val LOADING_DATA = "Ładowanie danych"
	override val CALENDAR = "Kalendarz"
	override val LIST = "Lista"
	override val YOU_ARE_LATE = "Spóźniasz się na"
	override val YOU_ARE_IN_TIME = "Masz czas"
	override val YOU_LATED = "Zarejestrowane spóźnieniе o"
	override val INCOME_FIXED = "Przybycie rejestrowane o"
	override val BAD_OUTCOME_FIXED = "Zarejestrowane wczesne odejście o"
	override val OUTCOME_FIXED = "Oejście rejestrowane o"
	override val YOUR_WORKING_CALENDAR = "Twój harmonogram pracy"
	override val MONTH_REMARKS = "Uwagi na miesiąc"
	override val INCOME_DIDNT_FIX = "Nie ma zapisu o przybyciu"
	override val LATE_ON = "Spóźnienie na"
	override val LATE = "Spóźnienie"
	override val BAD_OUTCOME = "Wczesne odejście na"
	override val OUTCOME_DIDNT_FIX = "Nie zarejestrowano odejścia"
	override val USER_DIDNT_SET = "Użytkownik nie zainstalowany!"
	override val INCOME = "Przybycie"
	override val OUTCOME = "Odejście"
	override val RE_OUTCOME = "Zarejestrować ponownie"
	override val SCAN_FROM_TABLET = "Zeskanuj kod QR z ekranu specjalnego tabletu."
	override val LOAD_SCANNER = "Ładowanie skanera"
	override val SCAN_ERROR = "Błąd skanera"
	override val SCAN_PERMISSION_ERROR = "Błąd żądania uprawnień"
	override val BACK = "Powrót"
	override val SET_USER_SUCCESS = "Użytkownik został pomyślnie zainstalowany"
	override val USER_DIDNT_SET_2 = "Użytkownik nie jest zainstalowany. Skontaktuj się z administratorem systemu."
	override val UNKNOWN_ERROR = "Nieznany błąd"
	override val WARNING = "Uwaga"
	override val GEOLOCATION_WARNING = "Geolokalizacja musi być włączona, aby rejestrować przybycie/odejście."
	override val DATA_SENDING = "Czas jest ustalony. Wysyłanie danych"
	override val DONE = "Gotowe!"
	override val FIX_TIME = "Czas rejestracji"
	override val UPDATE_PAGE_QUESTION = "Odświeżyć stronę?"
	override val HOME = "Główna"
	override val SCANNER = "Skaner"
	override val HISTORY = "Historia"
	override val GEOLOCATION_ERROR = "Błąd odbierania geolokalizacji"
	override val GEOLOCATION_PERMISSION_ERROR = "Błąd uprawnień geolokalizacji"
	override val VACATION = "Urlop"
	override val IN_WORK = "W pracy"
	override val ON_OBJECT = "Na terenie obiektu"
	override val REMOTE_WORK = "Zdalnie"
	override val SERVICE_FAIL = "Błąd dostępu do usługi"
	override val SUNDAY = "nd"
	override val MONDAY = "pn"
	override val TUESDAY = "wt"
	override val WEDNESDAY = "śr"
	override val THURSDAY = "cz"
	override val FRIDAY = "pt"
	override val SATURDAY = "sb"
	override val JANUARY = "Styczeń"
	override val FEBRUARY = "Luty"
	override val MARCH = "Marzec"
	override val APRIL = "Kwiecień"
	override val MAY = "Maj"
	override val JUNE = "Czerwiec"
	override val JULY = "Lipiec"
	override val AUGUST = "Sierpień"
	override val SEPTEMBER = "Wrzesień"
	override val OCTOBER = "Październik"
	override val NOVEMBER = "Listopad"
	override val DECEMBER = "Grudzień"
	override val JANUARY_2 = "stycznia"
	override val FEBRUARY_2 = "lutego"
	override val MARCH_2 = "marca"
	override val APRIL_2 = "kwietnia"
	override val MAY_2 = "maja"
	override val JUNE_2 = "czerwca"
	override val JULY_2 = "lipca"
	override val AUGUST_2 = "sierpnia"
	override val SEPTEMBER_2 = "września"
	override val OCTOBER_2 = "października"
	override val NOVEMBER_2 = "listopada"
	override val DECEMBER_2 = "grudnia"
	override val MINUTE = "minuta"
	override val MINUTES = "minuty"
	override val MINUTES_2 = "minut"
	override val HOUR = "godzina"
	override val HOURS = "godziny"
	override val HOURS_2 = "godzin"
	override val CREATE_SCANNER_ERROR = "Błąd podczas tworzenia skanera"
	override val STOP_SCANNER_ERROR = "Błąd podczas zatrzymania skanera"
	override val SCANNER_HANDLE_ERROR = "Błąd przetwarzania skanowania"
	override val CREATE_SCANNER_PARAMETER_ERROR = "Błąd podczas tworzenia parametrów skanera"
	override val START_SCAN_ERROR = "Błąd rozpoczęcia skanowania"
	override val IN_WORK2 = "W pracy"
	override val BUSINESS_TRIP = "Podróż służbowa"
	override val SICK_LEAVE = "Zwolnienie lekarskie"
	override val MATERNITY_LEAVE = "Urlop macierzyński"
	override val DUTY_ON_ZAHODNIA = "Cło na Zachodniej"
	override val OUT_OF_POCKET_TIME_OFF = "Czas wolny na własny koszt"
	override val WEEKEND_WORK = "Praca w weekend"
	override val ABSENCE_TO_3_HOURS = "Usprawiedliwiona nieobecność (nieobecność do 3 godzin)"
	override val ABSENCE_MORE_3_HOURS = "Nie bez powodu wziąłem ponad trzy godziny wolnego"
	override val UNEXCUSED_ABSENCE = "Nieusprawiedliwione nieobecności"
	override val TRUANCY = "Absencja"
	override val OTHER = "Inne"
	override val UNKNOWN_ABSENCE_MODE = "Nieznany rodzaj nieobecności"
	override val INCORRECT_QR = "Nieprawidłowy kod QR"
	override val USER_IS_OUTSIDE_OFFICE = "Użytkownik poza biurem"
	override val GEOLOCATION_GETTING = "Określamy geolokalizację."
	override val GEOLOCATION_GETTING_OFFLINE = "Określamy geolokalizację (internet może być wymagany)."
	override val TIME_GOT = "Czas rejestracji otrzymaliśmy."
	override val CANCEL = "Rezygnacja"
	override val SET_USER = "Ustaw użytkownika"
	override val SEND_QUEUE = "Wysyłanie zapisanych fiksacji"
	override val QUEUE_WARNING = "Czas został zarejestrowany, ale dane nie mogły zostać wysłane (zostaną wysłane później)."
	override val OFFLINE_ERROR = "Sprawdź połączenie sieciowe!"
	override val DEVICE_NOT_ALLOWED = "Korzystanie z aplikacji na tym urządzeniu jest zabronione."
	override val WAIT_FINISH = "Poczekaj na zakończenie!"
}

class PoltLanguage : Language() {
	override val TEST_MODE = "Тестовий режим"
	override val SOMETHING_WRONG = "Шось пошло не так. Спробуйте знов."
	override val ERROR = "Ошибка"
	override val NO_DATA = "Нема данних"
	override val LOADING_DATA = "Загружаємо данні"
	override val CALENDAR = "Календар"
	override val LIST = "Список"
	override val YOU_ARE_LATE = "Ви спізнюєтесь на"
	override val YOU_ARE_IN_TIME = "Ви вспіваєте"
	override val YOU_LATED = "Зафіксовано запізнення в"
	override val INCOME_FIXED = "Прихід зафіксований в"
	override val BAD_OUTCOME_FIXED = "Зафіксован ранній ухід в"
	override val OUTCOME_FIXED = "Ухід зафіксован в"
	override val YOUR_WORKING_CALENDAR = "Ваш робочий графік"
	override val MONTH_REMARKS = "Замічанія за місяць"
	override val INCOME_DIDNT_FIX = "Не зафіксован прихід"
	override val LATE_ON = "Запізнення на"
	override val LATE = "Запізнення"
	override val BAD_OUTCOME = "Ухід раніше на"
	override val OUTCOME_DIDNT_FIX = "Не зафіксован ухід"
	override val USER_DIDNT_SET = "Пользователь не встановлений!"
	override val INCOME = "Прихід"
	override val OUTCOME = "Ухід"
	override val RE_OUTCOME = "Зафіксувати ще раз"
	override val SCAN_FROM_TABLET = "Отсканьте QR-код з экрану спеціального планшета."
	override val LOAD_SCANNER = "Загружаємо сканер"
	override val SCAN_ERROR = "Ошибка сканера"
	override val SCAN_PERMISSION_ERROR = "Ошибка запроса на дозвол"
	override val BACK = "Вернутися"
	override val SET_USER_SUCCESS = "Пользователь успішно встановлений"
	override val USER_DIDNT_SET_2 = "Пользователь не встановлений. Обратіться до самого себе."
	override val UNKNOWN_ERROR = "Неізвєсна ошибка"
	override val WARNING = "Попередження"
	override val GEOLOCATION_WARNING = "Для фіксації прихіда/ухіда нужно включити геолокацію."
	override val DATA_SENDING = "Время зафіксувалося. Відправляємо данні"
	override val DONE = "Готово!"
	override val FIX_TIME = "Время фіксації"
	override val UPDATE_PAGE_QUESTION = "Обновити сторінку?"
	override val HOME = "Главна"
	override val SCANNER = "Сканер"
	override val HISTORY = "Історія"
	override val GEOLOCATION_ERROR = "Ошибка отримання геолокації"
	override val GEOLOCATION_PERMISSION_ERROR = "Ошибка отримання дозвола на геолокацію"
	override val VACATION = "Отпуск"
	override val IN_WORK = "На роботі"
	override val ON_OBJECT = "На об'екті"
	override val REMOTE_WORK = "Віддалено"
	override val SERVICE_FAIL = "Ошибка доступу к сервісу"
	override val SUNDAY = "нд"
	override val MONDAY = "пн"
	override val TUESDAY = "вт"
	override val WEDNESDAY = "ср"
	override val THURSDAY = "чт"
	override val FRIDAY = "пт"
	override val SATURDAY = "сб"
	override val JANUARY = "Січень"
	override val FEBRUARY = "Лютий"
	override val MARCH = "Березень"
	override val APRIL = "Квітень"
	override val MAY = "Травень"
	override val JUNE = "Червень"
	override val JULY = "Липень"
	override val AUGUST = "Серпень"
	override val SEPTEMBER = "Вересень"
	override val OCTOBER = "Жовтень"
	override val NOVEMBER = "Листопад"
	override val DECEMBER = "Грудень"
	override val JANUARY_2 = "січня"
	override val FEBRUARY_2 = "лютого"
	override val MARCH_2 = "березня"
	override val APRIL_2 = "квітня"
	override val MAY_2 = "травня"
	override val JUNE_2 = "червня"
	override val JULY_2 = "липня"
	override val AUGUST_2 = "серпня"
	override val SEPTEMBER_2 = "вересня"
	override val OCTOBER_2 = "жовтня"
	override val NOVEMBER_2 = "листопада"
	override val DECEMBER_2 = "грудня"
	override val MINUTE = "минута"
	override val MINUTES = "минути"
	override val MINUTES_2 = "минут"
	override val HOUR = "час"
	override val HOURS = "часа"
	override val HOURS_2 = "часів"
	override val CREATE_SCANNER_ERROR = "Ошибка створення сканера"
	override val STOP_SCANNER_ERROR = "Ошибка коли була остановка сканера"
	override val SCANNER_HANDLE_ERROR = "Ошибка обрабки скана"
	override val CREATE_SCANNER_PARAMETER_ERROR = "Ошибка при створенні параметрів сканера"
	override val START_SCAN_ERROR = "Ошибка начала сканування"
	override val IN_WORK2 = "Одробив"
	override val BUSINESS_TRIP = "Командировка"
	override val SICK_LEAVE = "Больнічний"
	override val MATERNITY_LEAVE = "Відпустка декретна"
	override val DUTY_ON_ZAHODNIA = "Дежурство на Заходній"
	override val OUT_OF_POCKET_TIME_OFF = "Відгул за свій щот"
	override val WEEKEND_WORK = "Робота у вихідний"
	override val ABSENCE_TO_3_HOURS = "Отпросивсь по уважитєльной причині (відсутствіє до 3-х часів)"
	override val ABSENCE_MORE_3_HOURS = "Отпросивсь по уважитєльной причині більш 3-х часів"
	override val UNEXCUSED_ABSENCE = "Отпросивсь без уважитєльної причини"
	override val TRUANCY = "Прогул"
	override val OTHER = "Друге"
	override val UNKNOWN_ABSENCE_MODE = "Неізвєсный тип відсутствія"
	override val INCORRECT_QR = "Мені QR-код не нравиться"
	override val USER_IS_OUTSIDE_OFFICE = "Пользователь не в офісі"
	override val GEOLOCATION_GETTING = "Оприділяем де ти."
	override val GEOLOCATION_GETTING_OFFLINE = "Оприділяем де ти (може бути нужним інтернет)."
	override val TIME_GOT = "Время фіксації отримали."
	override val CANCEL = "Отмєна"
	override val SET_USER = "Встановити пользоватєля"
	override val SEND_QUEUE = "Відправка сохраньонних фіксаций"
	override val QUEUE_WARNING = "Время зафіксувалось, але дані відправить не вдалося (будут відправлені позже)."
	override val OFFLINE_ERROR = "Перевірте підключення к сєті!"
	override val DEVICE_NOT_ALLOWED = "Користування пріложенієм на цьом устройстві заборонено."
	override val WAIT_FINISH = "Почекайте поки не завершиться!"
}